import invariant from 'invariant'
import isNaN from 'lodash/isNaN'
import { getLocale } from 'pmt-modules/i18n'
import { isKiosk } from 'pmt-modules/environment'

/**
 * Currency is set as global var
 * we may set this for example when we fetch the restaurant
 * Default still remains as EUR
 */
let _currency = 'EUR'

export const setCurrency = currency => (_currency = currency)

// deprecated, use formatPriceWithCurrency instead
// this will allow to have 123$ or $123 depending on the locale, and so on
export const getCurrencySymbol = (currency = _currency) => {
  switch (currency) {
    case 'AED':
      return 'د.إ'
    case 'ALL':
      return 'L'
    case 'AMD':
      return '֏'
    case 'AOA':
      return 'Kz'
    case 'ARS':
      return 'AR$'
    case 'AUD':
      return 'A$'
    case 'AWG':
      return 'ƒ'
    case 'AZN':
      return '₼'
    case 'BAM':
      return 'KM'
    case 'BBD':
      return 'Bds$'
    case 'BDT':
      return '৳'
    case 'BGN':
      return 'Лв'
    case 'BHD':
      return '.د.ب'
    case 'BMD':
      return '$'
    case 'BND':
      return 'B$'
    case 'BOB':
      return 'Bs.'
    case 'BRL':
      return 'R$'
    case 'BSD':
      return 'B$'
    case 'BWP':
      return 'P'
    case 'BYN':
      return 'Br'
    case 'BZD':
      return 'BZ$'
    case 'CAD':
      return 'C$'
    case 'CHF':
      return 'CHF'
    case 'CLP':
      return 'CLP$'
    case 'CNH':
      return '¥'
    case 'CNY':
      return '¥'
    case 'COP':
      return 'COL$'
    case 'CRC':
      return '₡'
    case 'CUP':
      return '₱'
    case 'CVE':
      return 'Esc'
    case 'CZK':
      return 'Kč'
    case 'DJF':
      return 'Fdj'
    case 'DKK':
      return 'kr'
    case 'DOP':
      return 'RD$'
    case 'DZD':
      return 'دج'
    case 'EGP':
      return 'E£'
    case 'ETB':
      return 'Br'
    case 'EUR':
      return '€'
    case 'FJD':
      return 'FJ$'
    case 'FKP':
      return '£'
    case 'GBP':
      return '£'
    case 'GEL':
      return '₾'
    case 'GHS':
      return 'GH₵'
    case 'GIP':
      return '£'
    case 'GMD':
      return 'D'
    case 'GNF':
      return 'FG'
    case 'GTQ':
      return 'Q'
    case 'GYD':
      return 'G$'
    case 'HKD':
      return 'HK$'
    case 'HNL':
      return 'L'
    case 'HTG':
      return 'G'
    case 'HUF':
      return 'Ft'
    case 'IDR':
      return 'Rp'
    case 'ILS':
      return '₪'
    case 'INR':
      return '₹'
    case 'IQD':
      return 'ع.د'
    case 'ISK':
      return 'kr'
    case 'JMD':
      return 'J$'
    case 'JOD':
      return 'JD'
    case 'JPY':
      return '¥'
    case 'KES':
      return 'KSh'
    case 'KGS':
      return 'сом'
    case 'KHR':
      return '៛'
    case 'KMF':
      return 'CF'
    case 'KRW':
      return '₩'
    case 'KWD':
      return 'KD'
    case 'KYD':
      return 'CI$'
    case 'KZT':
      return '₸'
    case 'LAK':
      return '₭'
    case 'LBP':
      return 'ل.ل'
    case 'LKR':
      return 'Rs'
    case 'LYD':
      return 'LD'
    case 'MAD':
      return 'د.م.'
    case 'MDL':
      return 'L'
    case 'MKD':
      return 'ден'
    case 'MMK':
      return 'K'
    case 'MNT':
      return '₮'
    case 'MOP':
      return 'MOP$'
    case 'MRU':
      return 'UM'
    case 'MUR':
      return '₨'
    case 'MVR':
      return 'Rf'
    case 'MWK':
      return 'MK'
    case 'MXN':
      return 'MX$'
    case 'MYR':
      return 'RM'
    case 'MZN':
      return 'MT'
    case 'NAD':
      return 'N$'
    case 'NGN':
      return '₦'
    case 'NIO':
      return 'C$'
    case 'NOK':
      return 'kr'
    case 'NPR':
      return '₨'
    case 'NZD':
      return 'NZ$'
    case 'OMR':
      return '﷼'
    case 'PAB':
      return 'B/.'
    case 'PEN':
      return 'S/'
    case 'PGK':
      return 'K'
    case 'PHP':
      return '₱'
    case 'PKR':
      return '₨'
    case 'PLN':
      return 'zł'
    case 'PYG':
      return '₲'
    case 'QAR':
      return '﷼'
    case 'RON':
      return 'lei'
    case 'RSD':
      return 'дин'
    case 'RUB':
      return '₽'
    case 'RWF':
      return 'FRw'
    case 'SAR':
      return '﷼'
    case 'SBD':
      return 'SI$'
    case 'SCR':
      return '₨'
    case 'SEK':
      return 'kr'
    case 'SGD':
      return 'S$'
    case 'SHP':
      return '£'
    case 'SLE':
      return 'Le'
    case 'SOS':
      return 'S'
    case 'SRD':
      return 'SR$'
    case 'STN':
      return 'Db'
    case 'SVC':
      return '$'
    case 'SZL':
      return 'L'
    case 'THB':
      return '฿'
    case 'TND':
      return 'د.ت'
    case 'TOP':
      return 'T$'
    case 'TRY':
      return '₺'
    case 'TTD':
      return 'TT$'
    case 'TWD':
      return 'NT$'
    case 'TZS':
      return 'TSh'
    case 'UAH':
      return '₴'
    case 'UGX':
      return 'USh'
    case 'USD':
      return '$'
    case 'UYU':
      return '$U'
    case 'UZS':
      return 'лв'
    case 'VEF':
      return 'Bs'
    case 'VND':
      return '₫'
    case 'VUV':
      return 'VT'
    case 'WST':
      return 'WS$'
    case 'XAF':
      return 'FCFA'
    case 'XCD':
      return 'EC$'
    case 'XCG':
      return 'XCG'
    case 'XOF':
      return 'CFA'
    case 'XPF':
      return '₣'
    case 'YER':
      return '﷼'
    case 'ZAR':
      return 'R'
    case 'ZMW':
      return 'ZK'
    default:
      return currency
  }
}

/**
 * ISO_4217 format expected
 * @link https://www.wikiwand.com/en/ISO_4217
 */
export const Currencies = {
  AED: 'AED', // UAE Dirham
  ALL: 'ALL', // Albanian Lek
  AMD: 'AMD', // Armenian Dram
  AOA: 'AOA', // Angolan Kwanza
  ARS: 'ARS', // Nuevo Argentine Peso
  AUD: 'AUD', // Australian Dollar
  AWG: 'AWG', // Aruban Guilder
  AZN: 'AZN', // Azerbaijani manat
  BAM: 'BAM', // Bosnia and Herzegovina Convertible Marks
  BBD: 'BBD', // Barbados Dollar
  BDT: 'BDT', // Bangladesh Taka
  BGN: 'BGN', // New Bulgarian Lev
  BHD: 'BHD', // Bahraini Dinar
  BMD: 'BMD', // Bermudian Dollar
  BND: 'BND', // Brunei Dollar
  BOB: 'BOB', // Bolivia Boliviano
  BRL: 'BRL', // Brazilian Real
  BSD: 'BSD', // Bahamian Dollar
  BWP: 'BWP', // Botswana Pula
  BYN: 'BYN', // New Belarusian Ruble
  BZD: 'BZD', // Belize Dollar
  CAD: 'CAD', // Canadian Dollar
  CHF: 'CHF', // Swiss Franc
  CLP: 'CLP', // Chilean Peso
  CNH: 'CNH', // Yuan Renminbi (offshore)
  CNY: 'CNY', // Yuan Renminbi (onshore)
  COP: 'COP', // Colombian Peso
  CRC: 'CRC', // Costa Rican Colon
  CUP: 'CUP', // Cuban Peso
  CVE: 'CVE', // Cape Verdi Escudo
  CZK: 'CZK', // Czech Koruna
  DJF: 'DJF', // Djibouti Franc
  DKK: 'DKK', // Danish Krone
  DOP: 'DOP', // Dominican Republic Peso
  DZD: 'DZD', // Algerian Dinar
  EGP: 'EGP', // Egyptian Pound
  ETB: 'ETB', // Ethiopian Birr
  EUR: 'EUR', // Euro
  FJD: 'FJD', // Fiji Dollar
  FKP: 'FKP', // Falkland Islands Pound
  GBP: 'GBP', // Pound Sterling
  GEL: 'GEL', // Georgian Lari
  GHS: 'GHS', // Ghanaian Cedi (3rd)
  GIP: 'GIP', // Gibraltar Pound
  GMD: 'GMD', // Gambia Delasi
  GNF: 'GNF', // Guinea Franc
  GTQ: 'GTQ', // Guatemala Quetzal
  GYD: 'GYD', // Guyanese Dollar
  HKD: 'HKD', // Hong Kong Dollar
  HNL: 'HNL', // Honduras Lempira
  HTG: 'HTG', // Haitian Gourde
  HUF: 'HUF', // Hungarian Forint
  IDR: 'IDR', // Indonesian Rupiah
  ILS: 'ILS', // New Israeli Scheqel
  INR: 'INR', // Indian Rupee
  IQD: 'IQD', // Iraqi Dinar
  ISK: 'ISK', // Iceland Krona
  JMD: 'JMD', // Jamaican Dollar
  JOD: 'JOD', // Jordanian Dinar
  JPY: 'JPY', // Japanese Yen
  KES: 'KES', // Kenyan Shilling
  KGS: 'KGS', // Kyrgyzstan Som
  KHR: 'KHR', // Cambodia Riel
  KMF: 'KMF', // Comoro Franc
  KRW: 'KRW', // South-Korean Won
  KWD: 'KWD', // Kuwaiti Dinar
  KYD: 'KYD', // Cayman Islands Dollar
  KZT: 'KZT', // Kazakhstani Tenge
  LAK: 'LAK', // Laos Kip
  LBP: 'LBP', // Lebanese Pound
  LKR: 'LKR', // Sri Lanka Rupee
  LYD: 'LYD', // Libyan Dinar
  MAD: 'MAD', // Moroccan Dirham
  MDL: 'MDL', // Moldovia Leu
  MKD: 'MKD', // Macedonian Denar
  MMK: 'MMK', // Myanmar Kyat
  MNT: 'MNT', // Mongolia Tugrik
  MOP: 'MOP', // Macau Pataca
  MRU: 'MRU', // Mauritania Ouguiya
  MUR: 'MUR', // Mauritius Rupee
  MVR: 'MVR', // Maldives Rufiyaa
  MWK: 'MWK', // Malawi Kwacha
  MXN: 'MXN', // Mexican Peso
  MYR: 'MYR', // Malaysian Ringgit
  MZN: 'MZN', // Mozambican Metical
  NAD: 'NAD', // Namibian Dollar
  NGN: 'NGN', // Nigerian Naira
  NIO: 'NIO', // Nicaragua Cordoba Oro
  NOK: 'NOK', // Norwegian Krone
  NPR: 'NPR', // Nepalese Rupee
  NZD: 'NZD', // New Zealand Dollar
  OMR: 'OMR', // Rial Omani
  PAB: 'PAB', // Panamanian Balboa
  PEN: 'PEN', // Peruvian Nuevo Sol
  PGK: 'PGK', // New Guinea Kina
  PHP: 'PHP', // Philippine Peso
  PKR: 'PKR', // Pakistan Rupee
  PLN: 'PLN', // New Polish Zloty
  PYG: 'PYG', // Paraguay Guarani
  QAR: 'QAR', // Qatari Rial
  RON: 'RON', // New Romanian Lei
  RSD: 'RSD', // Serbian Dinar
  RUB: 'RUB', // Russian Ruble
  RWF: 'RWF', // Rwanda Franc
  SAR: 'SAR', // Saudi Riyal
  SBD: 'SBD', // Solomon Island Dollar
  SCR: 'SCR', // Seychelles Rupee
  SEK: 'SEK', // Swedish Krone
  SGD: 'SGD', // Singapore Dollar
  SHP: 'SHP', // St. Helena Pound
  SLE: 'SLE', // Sierra Leone Leone
  SOS: 'SOS', // Somalia Shilling
  SRD: 'SRD', // Surinamese dollar
  STN: 'STN', // Sao Tome & Principe Dobra
  SVC: 'SVC', // El Salvador Colón
  SZL: 'SZL', // Swaziland Lilangeni
  THB: 'THB', // Thai Baht
  TND: 'TND', // Tunisian Dinar
  TOP: 'TOP', // Tonga Pa'anga
  TRY: 'TRY', // New Turkish Lira
  TTD: 'TTD', // Trinidad & Tobago Dollar
  TWD: 'TWD', // New Taiwan Dollar
  TZS: 'TZS', // Tanzanian Shilling
  UAH: 'UAH', // Ukraine Hryvnia
  UGX: 'UGX', // Uganda Shilling
  USD: 'USD', // US Dollars
  UYU: 'UYU', // Peso Uruguayo
  UZS: 'UZS', // Uzbekistani Som
  VEF: 'VEF', // Venezuelan Bolívar
  VND: 'VND', // Vietnamese New Dong
  VUV: 'VUV', // Vanuatu Vatu
  WST: 'WST', // Samoan Tala
  XAF: 'XAF', // CFA Franc BEAC
  XCG: 'XCG', // Caribbean Guilder
  XCD: 'XCD', // East Caribbean Dollar
  XOF: 'XOF', // CFA Franc BCEAO
  XPF: 'XPF', // CFP Franc
  YER: 'YER', // Yemeni Rial
  ZAR: 'ZAR', // South African Rand
  ZMW: 'ZMW', // Zambian Kwacha
}

export const getFloorAmount = amount => (Math.floor(amount * 100) / 100).toFixed(2)

// this transforms the amount in a formatted string
export const getRoundAmount = amount => (Math.round(amount * 100) / 100).toFixed(2)

// this rounds the amount (but it's still a number)
export const getRoundAmountNumber = amount => Math.round(amount * 100) / 100

export const getCeilAmount = amount => (Math.ceil(amount * 100) / 100).toFixed(2)

// result sometimes goes from 9.7 to 969.9999999999999, so we round it.
export const getAmountInCents = amount => Math.round(amount * 100)

// Helper: check if currency is a valid ISO 4217 code
const isValidCurrency = code => {
  try {
    new Intl.NumberFormat('en', { style: 'currency', currency: code })
    return true
  } catch {
    return false
  }
}

export const formatPriceWithCurrency = (price, currency = _currency) => {
  invariant(!isNaN(price), `${price} is not a number`)
  let locale = getLocale() || 'fr'

  // If unknown or invalid currency → use ¤
  if (!currency || !isValidCurrency(currency)) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'XXX', // ISO code for "no currency". should produce ¤ in most locales.
      currencyDisplay: 'symbol',
    })
      .format(price)
      .replace('XXX', multipleOrUnknownCurrency) // force ¤ if needed
  }

  if (currency === 'CHF') {
    // for swiss amounts, we want to be sure the amount will be formatted in the "swiss" way,
    // aka it-CH/de-CH/fr-CH, even if the user's browser is configured as  "it" or "it_IT"
    // (because swiss people don't bother to configure computer/browser with the country-related locale,
    // but complain when the formatting is not as they are used to)
    if (locale.startsWith('it')) {
      locale = 'it-CH'
    }
    if (locale.startsWith('fr')) {
      locale = 'fr-CH'
    }
    if (locale.startsWith('de')) {
      locale = 'de-CH'
    }
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    // we don't define minimumFractionDigits / maximumFractionDigits so the decimals will be defined based on the currency:
    // Most currencies (e.g., USD, EUR) default to 2 decimal places.
    // Currencies like ISK, JPY (without fractional units) default to 0 decimal places.
    // Certain currencies like KWD (Kuwaiti Dinar) default to 3 decimal places.

    // kiosk is using chrome 65, which reached its end of support on April 24, 2018.
    currencyDisplay: isKiosk() ? 'symbol' : 'narrowSymbol', // to have $ and not US$ (= the daily-life symbol, and not the very-specific symbol). The ambiguity (between US$ and CA$, for example) should not be a problem, as the restaurant belongs to only one country, so the $ symbol is the one of this country
  }).format(price)
}

/**
 * "step" value to use in an input of type "number"
 */
export const getStepValue = (currency = _currency) => {
  // Use Intl.NumberFormat to determine the fraction digits for the selected currency
  const formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency,
  })
  const fractionDigits = formatter.resolvedOptions().maximumFractionDigits

  // Calculate the step based on fraction digits (e.g., 2 -> 0.01, 0 -> 1)
  const stepValue = Math.pow(10, -fractionDigits)
  return stepValue
}

export const formatPrice = price => {
  const priceAsFloat = price !== null ? parseFloat(price) : 0
  return priceAsFloat.toLocaleString(getLocale() || 'fr', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export const formatPercent = v => `${v} %`

export const convertMillionPrice = price => parseFloat(price / 1000000)

export const formatMillionPrice = price => formatPrice(convertMillionPrice(price))

export const multipleOrUnknownCurrency = '¤'

export const formatMillionPriceWithCurrency = (price, currency = multipleOrUnknownCurrency) =>
  formatPriceWithCurrency(convertMillionPrice(price), currency)

export const truncatePrice = price => {
  return parseFloat(price.toFixed(2))
}
